import React, { useState, useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import { useDispatch, useSelector } from 'react-redux';

import { Badge as BadgeIcon } from '@mui/icons-material';

import { ModalButtonContent } from '../ModalButtonContent';
import { ModalPopup } from '../../Elements/Modal';

import { EmploymentModalContent } from './EmploymentModalContent';

import {
  patchUserEmploymentInfo,
  getUserEmploymentInfo,
  createUserEmploymentInfo,
} from '../../../actions';

import { EMPLOYMENT_MODAL, EMPLOYMENT_CARD_TITLE } from '../../../constants/Dashboard/Employment';

export const Employment = ({ user, tokenValue }) => {
  const [open, setOpen] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);

  const dispatch = useDispatch();
  const { loading, ...otherEmploymentInfo } = useSelector(
    ({ employmentReducer }) => employmentReducer,
  );

  useEffect(() => {
    if (user?.id && tokenValue) {
      dispatch(getUserEmploymentInfo({ id: user.id, tokenValue }));
    }
  }, [user?.id, tokenValue]);

  useEffect(() => {
    setIsConfirmed(!!otherEmploymentInfo['Current Annual Salary']);
  }, [otherEmploymentInfo['Current Annual Salary']]);

  const handleOpen = () => {
    setOpen(true);
    mixpanel.track('Dashboard Modal', {
      user_id: user.id,
      distinct_id: user.id,
      Modal: 'Employment',
      action: 'Open',
      confirmed: isConfirmed,
    });
  };
  const handleClose = () => {
    setOpen(false);
    mixpanel.track('Dashboard Modal', {
      user_id: user?.id,
      distinct_id: user?.id,
      Modal: 'Employment',
      action: 'Close',
      confirmed: isConfirmed,
    });
  };

  const handleConfirm = ({ employmentInfo }) => {
    setOpen(false);
    if (!user?.id) {
      return;
    }

    mixpanel.track('Dashboard Modal', {
      user_id: user?.id,
      Modal: 'Employment',
      action: 'Confirm',
    });

    setIsConfirmed(true);

    if (otherEmploymentInfo?.id) {
      dispatch(
        patchUserEmploymentInfo({
          employmentInfo: { ...employmentInfo, userId: user?.id, id: otherEmploymentInfo.id },
          tokenValue,
        }),
      );
    } else {
      dispatch(
        createUserEmploymentInfo({
          employmentInfo: { ...employmentInfo, userId: user?.id },
          tokenValue,
        }),
      );
    }
  };

  return (
    <div className="dashboard-user-info-row-item">
      <ModalPopup
        buttonContent={
          <ModalButtonContent
            isConfirmed={isConfirmed}
            modalButtonIcon={<BadgeIcon sx={{ mr: 2 }} />}
            modalButtonTitle={EMPLOYMENT_CARD_TITLE}
            loading={loading}
          />
        }
        modalContent={
          <EmploymentModalContent
            handleClose={handleClose}
            onConfirm={handleConfirm}
            employmentInfo={otherEmploymentInfo}
            user={user}
          />
        }
        title={EMPLOYMENT_MODAL.title}
        modalButtonId="employment-modal-button"
        handleOpen={loading === false ? handleOpen : () => {}}
        handleClose={handleClose}
        open={open}
      />
    </div>
  );
};
